<template>
  <div id="user-management">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-8 component-header component-header-left">
            <h6>Daftar User</h6>
          </div>
          <div class="col-md-4 component-header component-header-right">
            <button
              aria-label=""
              v-on:click="addUser"
              class="btn btn-success btn-icon-left"
              type="button"
            >
              <i class="bi bi-plus"></i> <span class="">Tambah User</span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="component-subtitle">
          <p class="m-b-15">
            Berikut merupakan daftar pengguna beserta hak aksesnya dalam proyek
            ini.
          </p>
        </div>
      </div>
      <div class="col-md-12">
        <table class="table table-bordered" id="users_table">
          <thead>
            <tr>
              <th class="text-center" width="2%">No</th>
              <th>Nama</th>
              <th>Username</th>
              <th>Email</th>
              <th>No Telepon</th>
              <th>Role</th>
              <th class="text-center" width="15%">Aksi</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="modal_data"
      :static="true"
    />
  </div>
</template>

<script>
import $ from "jquery";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_user from "@/views/components/settings/user/modal_add_user.vue";
import modal_edit_user from "@/views/components/settings/user/modal_edit_user.vue";
import modal_edit_akses from "@/views/components/super-admin/detail-project/modal_edit_akses.vue";
import modal_change_password from "@/views/components/super-admin/detail-project/modal_change_password.vue";
import swal from "sweetalert";

var modals = {
  title: "Tambah User",
  subtitle: "Silahkan masukan detail user baru yang akan ditambahkan",
  component: modal_add_user,
};

export default {
  name: "tab_user",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      currentModal: null,
      modal_key: 0,
      table: null,
      isError: false,
      role: [],
      modal_data: null,
      id_project: parseInt(atob(this.$route.query.ref)),
    };
  },
  methods: {
    addUser: function () {
      this.modal_key++;
      this.currentModal = modals;
    },
    clickAkses: function (index) {
      let modal = {
        title: "Akses User",
        subtitle: "",
        component: modal_edit_akses,
      };
      let newstrend = "off";
      let cleansing = "off";
      if ("capabilities" in this.users[index]) {
        if ("newstrend" in this.users[index].capabilities) {
          newstrend = this.users[index].capabilities.newstrend;
        }
        if ("datacleansing" in this.users[index].capabilities) {
          cleansing = this.users[index].capabilities.datacleansing;
        }
      }

      this.modal_data = [
        {
          id_user: this.users[index]._id.$oid,
          newstrend: newstrend,
          datacleansing: cleansing,
        },
      ];
      this.modal_key++;
      this.currentModal = modal;
    },
    getUser: function () {
      let api = process.env.VUE_APP_API_URL + "users/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 204) {
            this.users = {};
            this.isError = false;
          } else {
            this.users = response.data; // Data existed
            this.isError = false;
            let btn;
            this.table.clear();
            for (let index in this.users) {
              btn =
                '<center><button class="btn btn-sm btn-primary m-r-5 pass" title="Ubah Password"><i class="bi bi-key"></i></button><button class="btn btn-sm btn-complete m-r-5 ch"><i class="bi bi-pencil-square"></i></button><button class="btn btn-sm btn-warning aksesNew m-r-5"><i class="bi bi-person-lock"></i></button><button class="btn btn-sm btn-danger del"><i class="bi bi-trash"></i></button></center>';
              this.table.row
                .add([
                  parseInt(index) + 1,
                  this.users[index].nama,
                  this.users[index].username,
                  this.users[index].email,
                  this.users[index].phone,
                  this.role[this.users[index].role],
                  btn,
                ])
                .node().id = index;
              this.table.draw(false);
            }
          }
        })
        .catch((err) => {
          this.resp = err.response;
          this.isError = true;
        });
    },
    deleteUser: function (index) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus user tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: this.users[index]._id.$oid,
          };
          let api = process.env.VUE_APP_API_URL + "users-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.users.splice(index, 1);
                self.table
                  .row("#" + index)
                  .remove()
                  .draw(false);
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> User berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function (error) {
              console.log(error);
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus user.',
                  position: "top",
                  timeout: 4000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    editUser: function (index) {
      let modal = {
        title: "Edit User",
        subtitle: "Silahkan masukan detail user baru yang akan diupdate",
        component: modal_edit_user,
      };
      this.modal_data = [];
      this.modal_data[0] = this.users[index];
      this.currentModal = modal;
      this.modal_key++;
    },
    changePassword: function (index) {
      let modal = {
        title: "Ubah Password",
        subtitle: "Silahkan masukan password baru",
        component: modal_change_password,
      };
      this.modal_data = [];
      this.modal_data["user"] = this.users[index];
      this.currentModal = modal;
      this.modal_key++;
    },
  },
  created: function () {
    this.role[1] = "Super Admin";
    this.role[2] = "Admin";
    this.role[3] = "User";
    this.role[4] = "Viewer";
  },
  mounted: function () {
    this.table = $("#users_table").DataTable({
      columnDefs: [
        {
          targets: 6,
          orderable: false,
        },
      ],
    });
    this.getUser();
    let self = this;
    $("#users_table tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.deleteUser(id);
    });
    $("#users_table tbody").on("click", ".ch", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.editUser(id);
    });
    $("#users_table tbody").on("click", ".pass", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.changePassword(id);
    });

    $("#users_table tbody").on("click", ".aksesNew", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.clickAkses(id);
    });
  },
};
</script>